/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import Img from "gatsby-image/withIEPolyfill"

import Link from "./link"
import { ab } from "../theme"

const LocationTeaser = ({
  headline,
  infoHeadline,
  infoSubHeadline,
  link,
  linkText,
  image,
  imageAlt,
  mode,
  currentLanguage,
  seoLinks,
  children,
}) => {
  const renderInfoSubHeadline = () =>
    !infoSubHeadline ? null : (
      <h6
        sx={{
          fontSize: "14px",
          letterSpacing: 2,
          my: 1,
          textTransform: "uppercase",
          fontWeight: 1,
        }}
      >
        {infoSubHeadline}
      </h6>
    )

  return (
    <div
      className="location-teaser-container"
      sx={{ variant: "spacingContainer" }}
    >
      <h2 sx={{ variant: "styles.h2" }}>{headline}</h2>
      <div
        className="info-image-container"
        sx={{
          display: ab({ md: "flex" }),
          flexDirection: ab({ md: "row-reverse" }),
        }}
      >
        <div className="image-container" sx={{ flex: 2 }}>
          <Img style={{ height: "100%" }} fluid={image} alt={imageAlt} />
        </div>
        <div
          className="info-container"
          sx={{
            flex: 1,
            color: "#fff",
            bg: mode ? `modes.${mode}.primary` : "primary",
            p: 4,
          }}
        >
          {renderInfoSubHeadline()}
          <h3 sx={{ variant: "styles.h2" }}>{infoHeadline}</h3>
          {children}
          <div className="action" sx={{ mt: 4 }}>
            <Link
              to={link}
              sx={{
                variant: "styles.ghostButton",
                color: "#fff",
                border: "solid 1px #fff",
                py: 2,
                px: 4,
                "&:hover": {
                  bg: "#fff",
                  color: mode ? `modes.${mode}.primary` : "primary",
                },
              }}
            >
              {linkText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

LocationTeaser.propTypes = {
  headline: PropTypes.string.isRequired,
  infoHeadline: PropTypes.string.isRequired,
  infoSubHeadline: PropTypes.string,
  link: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  imageAlt: PropTypes.string,
  mode: PropTypes.oneOf(["", "pharma", "food", "environment"]),
  currentLanguage: PropTypes.oneOf(["", "de", "en"]),
  seoLinks: PropTypes.object,
  children: PropTypes.node,
}

LocationTeaser.defaultProps = {
  mode: "",
  seoLinks: {},
}

export default LocationTeaser
